import { render, staticRenderFns } from "./PriorityHandler.vue?vue&type=template&id=d874489a&scoped=true"
import script from "./PriorityHandler.vue?vue&type=script&lang=js"
export * from "./PriorityHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d874489a",
  null
  
)

export default component.exports